<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Student tag categories'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Student tag categories'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'studentTagCategories/index',
            deleteItem: 'studentTagCategories/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/student-tag-categories/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/student-tag-categories/add');
        }
    }
};
</script>
